<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-plane-departure"></i></span>{{ 'ExportDeclarationDetails.Header' | translate }}({{exportHeader?.exportDeclarationNo}})</h1>
    <p-card>
        <form class="pl-5 pr-5">
            <div class="field grid">
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.Forwarder' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.bookingForwarder | optionsMapping:forwarderOptions | replaceNullWith:'' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ExportMethod' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.exportType | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.PayeeType' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.billObjectType | optionsMapping:billObjectTypeOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.OriginCurrenAnt' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.exportAmount | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.Payee' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.billObject | optionsMapping:billObjectOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.AccountCurrenAnt' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.exportNtdAmount | replaceNullWith:'' }}
                </div>
                <div *ngIf="!isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.IdentificaitonNum' | translate }}</b></div>
                <div *ngIf="isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HK.IdentificaitonNum' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.docNo | replaceNullWith:'' }}
                </div>
                <div *ngIf="!isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FCAFOBPrice' | translate }}</b></div>
                <div *ngIf="isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HK.FCAFOBPrice' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.freeOnBoardAmount | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.DeliveryMode' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.shipMethod | optionsMapping:shipMethodOptions | replaceNullWith:'' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FCAFOBPriceAccount' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.freeOnBoardNtdAmount | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.BillComp' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.orgId | optionsMapping:orgIdOptions | replaceNullWith:'' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.PromotionFeeAccount' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.freeOnBoardChargeAmount | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.CustomerCode' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.consigneeKey | replaceNullWith:'' }} {{ exportHeader?.consigneeName | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.MAWB' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.mawbNo | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.DeclarationDate' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.exportDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HAWB' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.expressBill | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.DeclarationType' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.docType | optionsMapping:docTypeOptions | replaceNullWith:'' }}
                </div>
                <div *ngIf="this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HK.FlightNum1' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FlightNum1' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.flyNo1 | replaceNullWith:'' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.StatisticalMethods' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.docType1 | optionsMapping:docType1Options | replaceNullWith:'' }}
                </div>
                <div *ngIf="this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HK.FlightNum2' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FlightNum2' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.flyNo2 | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.Currency' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.currency | optionsMapping:currenyOptions | replaceNullWith:'' }}
                </div>
                <div *ngIf="this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.HK.FlightDate1' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FlightDate1' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.flyDt1 | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ExchangeRate' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.exchangeRate | replaceNullWith:'' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.FlightDate2' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.flyDt2 | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.DomesticForeign' | translate }}</b></div>
                <div *ngIf="!this.isHkFacility" class="mb-3 col-3 column-value">
                    {{ exportHeader?.exportCode | optionsMapping:exportCodeOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.Remarks' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.refernce | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ChargeParty' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.changeConsigneeId | replaceNullWith:'' }} {{ exportHeader?.changeConsigneeName | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.BookingNo' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.bookingNo | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.PortOfLoadingDischargeName' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.portOfLoadingDischargeName | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ToCountry' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.toCountry | optionsMapping:toCountryOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ContainerNo' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.containerNo | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ToCity' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.toCity | optionsMapping:toCityOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.TypeOfPackage' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.typeOfPackage | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ConsigneeCompany1' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.consigneeCompany1 | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ConsigneeCompany2' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.consigneeCompany2 | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ConsigneeAddress1' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.consigneeAddress1 | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ConsigneeAddress2' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.consigneeAddress2 | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.LetterOrgId' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.letterOrgId | optionsMapping:orgIdOptions | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.ErrorReason' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.errorReason | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.CreationTime' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.Creator' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.createUser | replaceNullWith:'' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.EditTime' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
                <div class="mb-3 col-3 column-label"><b>{{ 'ExportDeclarationDetails.Form.UpdateBy' | translate }}</b></div>
                <div class="mb-3 col-3 column-value">
                    {{ exportHeader?.updateUser | replaceNullWith:'' }}
                </div>
            </div>
            <p-accordion *ngIf="this.isHkFacility" [styleClass]="'mb-3'">
                <p-accordionTab header="{{ 'ExportDeclarationQuery.SubTable.Header.Details' | translate }}">
                    <p-table class="datatable" [value]="detailObjs">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.Sku' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.HkPrice' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.HsCode' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.Coo' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.Qty' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.GrossWeight' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.ExportQty' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.Unit' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.CreateUser' | translate }}</th>
                                <th>{{ 'ExportDeclarationDetails.SubTable.Form.CreateDt' | translate }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-detailObj>
                            <tr>
                                <td><div class="overflow-text">{{detailObj.sku}}</div></td>
                                <td><div class="overflow-text">{{detailObj.hkPrice}}</div></td>
                                <td><div class="overflow-text">{{detailObj.hsCode}}</div></td>
                                <td><div class="overflow-text">{{detailObj.coo}}</div></td>
                                <td><div class="overflow-text">{{detailObj.qty}}</div></td>
                                <td><div class="overflow-text">{{detailObj.grossWeight}}</div></td>
                                <td><div class="overflow-text">{{detailObj.exportQty}}</div></td>
                                <td><div class="overflow-text">{{detailObj.unit}}</div></td>
                                <td><div class="overflow-text">{{detailObj.createUser}}</div></td>
                                <td><div class="overflow-text">{{detailObj.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="7" style="text-align: center;">
                                    {{ 'Common.Table.NoData' | translate }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-accordionTab>
            </p-accordion>
            <div class="grid">
                <div class="col">
                    <button *ngIf="isShowEditBtn" pButton pRipple label="{{ 'Common.Button.Edit' | translate }}" (click)="gotoEdit($event)" class="mr-2"></button>
                    <button *ngIf="isShowCancelBtn" pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="gotoList($event)" class="p-button-secondary"></button>
                    <button *ngIf="isShowEditBtn && this.isHkFacility" pButton pRipple label="{{ 'ExportDeclarationDetails.Button.CallGets' | translate }}" (click)="callGets($event)" class="mr-2"></button>
                </div>
            </div>
        </form>
    </p-card>

    <p-dialog
        header="GETS 報關錯誤明細"
        appendTo="body"
        [(visible)]="showGetsErrorDialog"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '60vw', minWidth: '400px' }">
        <div class="mb-3" *ngIf="getsErrorSummary">
            <div class="p-3 border-round surface-100 text-color">
                {{ getsErrorSummary }}
            </div>
        </div>

        <p-table [value]="getsErrorDetails" [scrollable]="true" scrollHeight="320px">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 100px">錯誤碼</th>
                    <th style="width: 120px">欄位 ID</th>
                    <th style="width: 160px">欄位名稱</th>
                    <th>錯誤說明</th>
                    <th>修正建議</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td><span class="font-semibold">{{ row.errorCode || '-' }}</span></td>
                    <td>{{ row.fieldId || '-' }}</td>
                    <td>{{ row.fieldName || '-' }}</td>
                    <td>{{ row.description || row.message || '-' }}</td>
                    <td>{{ row.suggestion || '-' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="text-center">無欄位錯誤明細</td>
                </tr>
            </ng-template>
        </p-table>

        <ng-template pTemplate="footer">
            <button
                pButton
                pRipple
                label="關閉"
                icon="pi pi-times"
                class="p-button-secondary"
                (click)="showGetsErrorDialog = false"></button>
        </ng-template>
    </p-dialog>
</div>
